import { REGISTER_PENDING } from './index';
import { Action } from '../action';

export class RegisterPendingInitAction implements Action {
	readonly type = REGISTER_PENDING.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterPendingDestroyAction implements Action {
	readonly type = REGISTER_PENDING.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterPendingClickLoginAction implements Action {
	readonly type = REGISTER_PENDING.CLICK_LOGIN;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterPendingClickResentAction implements Action {
	readonly type = REGISTER_PENDING.CLICK_RESENT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterPendingClickLogoutAction implements Action {
	readonly type = REGISTER_PENDING.CLICK_LOGOUT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
